import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Amplify, Auth } from 'aws-amplify';
import { AmplifyService } from 'aws-amplify-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { scaleIn } from '../../shared/animations/modal.animation';

import { SocialAuthService, SocialUser, FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

import awsUser from '../social.provider'; 

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AmplifyService],
  animations: [scaleIn]
})

export class LoginComponent implements OnInit {

  authState: AuthState;
  // authState: any; 

  @Input() visible: boolean;

  displayLogin: boolean;
  @Output() closeLogin: EventEmitter<boolean> = new EventEmitter<boolean>();

  loginForm: FormGroup;
  errorMessage: string;
  isLoading: boolean;
  userNotAuthorized: boolean;
  loggedIn: boolean;
  public isShown: boolean;
  username: string;
  userGroup: any;
  recievedParams: any;

  user: SocialUser;

  constructor(private fb: FormBuilder, private amplifyService: AmplifyService, private router: Router, private activatedRoute: ActivatedRoute,
    private authService: SocialAuthService) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    })

    this.amplifyService = amplifyService;
    this.amplifyService.authStateChange$
      .subscribe(authState => {
        if (authState.state === 'signedIn') {
          this.loggedIn = true;
        }
      });

  }

  ngOnInit(): void {
    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
      console.log('Social user ==> ', this.user);
    });
  }

  async getCurrentAuthenticatedUser() {
    try {
      const { attributes } = await Auth.currentAuthenticatedUser();
      // console.log("ATTRIBUTES", attributes);
      this.username = attributes.name + " " + attributes.family_name;
      // console.log("Amplify currentAuthenticatedUser", attributes.name + " " + attributes.family_name);
    } catch (error) {
      // console.log("Amplify AuthenticatedUser Error", error);
    }
  }

  submit() {

    this.isLoading = true;
    const loginObj = {
      username: this.loginForm.value.email,
      password: this.loginForm.value.password
    }

    // console.log('loginObj => ', loginObj);

    this.SignIn(loginObj.username, loginObj.password);

    //this.getCurrentAuthenticatedUser();
  }

  async SignIn(userName: string, passWord: string) {
    Amplify.configure(
      {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: 'us-east-1:d3708511-4409-4327-be18-47452870133d',

        // REQUIRED - Amazon Cognito Region
        region: 'us-east-1',

        // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
        // Required only if it's different from Amazon Cognito Region
        identityPoolRegion: 'us-east-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'us-east-1_kc0P4U7YH',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '2r1j7mbji23eo4qoujo8ncm1dd',

        // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: false,
      }
    );

    try {

      const user = await Auth.signIn(userName, passWord);
      // console.log("user ", user);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {

        if (user.challengeParam.userAttributes.email === userName) {
          this.errorMessage = "";
          this.isLoading = false;
        }
      } else {
        if (user.attributes.email === userName) {
          this.errorMessage = "";
          this.isLoading = false;

          var username = user.attributes.name + " " + user.attributes.family_name;
          this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
          sessionStorage.setItem('CurrentAuthenticatedUser', username);
          sessionStorage.setItem('UserGroup', this.userGroup);

          if (this.userGroup === 'properties') {
            this.login();
          } else {
            this.signOut();
            this.isLoading = false;
            this.errorMessage = "Wrong credentials entered, please enter correct credentials!";
          }

        }
      }

    } catch (err) {
      // console.log('Err is ==> ', err);
      this.isLoading = false;
      if (err.code === 'NotAuthorizedException') {
        // The error happens when the incorrect password is provided
        this.errorMessage = "Wrong credentials entered, please enter correct credentials!";
        // console.log(err.code);
      } else if (err.code === 'UserNotFoundException') {
        // The error happens when the supplied username/email does not exist in the Cognito user pool
        this.errorMessage = "Wrong credentials entered, please enter correct credentials!";
        // console.log(err.code);
      }
      //else {
      // this.errorMessage = "Wrong credentials entered, please enter correct credentials!";
      // console.log("Last Unknown Error: ", err);
      //}
    }
  }

  async signInWithFederatedGoogle() {

    Amplify.configure(awsUser);

    try {
      Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google })
      .then((user) => {
        console.log('Google user ==> ', user)
      })
      .catch((error) => {
        console.log('Google Error ==> ', error); 
      }) 
    }
    catch (error) {
      console.log('Federated error ==> ', error);
    }

  }

  async signInWithFederatedFacebook() {

    Amplify.configure(awsUser);

    try {
      const loggedInUser = Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook }); 
      console.log('Logged in Federated user ==> ', loggedInUser); 
    }
    catch (error) {
      console.log('Federated error ==> ', error);
    }
  }

  async signInWithFederatedAmazon() {

    Amplify.configure(awsUser);

    try {
      Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Amazon })
    }
    catch (error) {
      console.log('Federated error ==> ', error);
    }
  }

  login() {
    if (this.loggedIn) {

      // this.router.navigateByUrl('/reg-page');

      // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      //   this.router.navigateByUrl('/home');
      // });

      location.reload();
      // console.log("User Logged In!");
      window.location.href = '#/home';
    }
  }

  onNavigateToForgetPassword() {
    this.router.navigate(['forgot-password']);
  }


  close() {
    this.displayLogin = false;
    this.loginForm.reset();
    this.closeLogin.emit(this.displayLogin);

    this.router.navigate(['.']);
  }

  signOut() {
    sessionStorage.clear();

    Auth.signOut({ global: true })
      .then(data => {
        console.log("Logout Data: ", data);
      })
      .catch(err =>
        console.log('Err ::', err));
  }

} 
